/**
 * Швидкі поля панелі розширених фільтрів (прототип v4, «Швидкі поля»): напрям, виконавець, призначив, пріоритет і термін — ті з них, що є
 * в типі запису; значення поля → умови фільтр-DSL. Чисті функції.
 */
import type { IRecordTypeDefinition } from '@platform/core/types';

/** Кошики терміну (прототип v4): прострочено · термін сьогодні · наступні 7 днів · пізніше · без терміну. */
export const dueBuckets: readonly string[] = ['overdue', 'today', 'week', 'later', 'none'];

/** Значення «не призначено» для виконавця. */
export const UNASSIGNED = '__none';

/** «Прострочено» — термін минув і статус поза глобальним DONE прототипу (isDone), як у швидкому фільтрі. */
const DUE_DSL: Readonly<Record<string, string>> = {
  overdue: 'isDone:eq:false;due:lt:today', today: 'due:eq:today', week: 'due:between:today,+7d', later: 'due:gt:+7d', none: 'due:empty',
};

/**
 * Ключі швидких полів, наявних у типі (без прихованих полів визначення), у порядку прототипу: `area` (напрям), `assignee` (виконавець), `assignedBy` (хто призначив — за
 * виконавцем), `priority` (варіанти), `due` (дата).
 */
export function quickFieldsOf(rt: IRecordTypeDefinition): string[] {
  const has = (key: string, type: string) => rt.fields.some((f) => f.key === key && f.type === type && !f.hidden);
  const person = has('assignee', 'user');
  return [has('area', 'area') ? 'area' : '', person ? 'assignee' : '', person ? 'assignedBy' : '', has('priority', 'select') ? 'priority' : '', has('due', 'date') ? 'due' : '']
    .filter(Boolean);
}

/** Умови фільтр-DSL значення швидкого поля; порожнє значення — без умов. Напрям — ідентифікатори вузла й піддерева через кому. */
export function quickFieldDsl(field: string, value: string): string {
  if (!value) return '';
  if (field === 'area') return `area:in:${value.split(',').map(encodeURIComponent).join(',')}`;
  if (field === 'assignee') return value === UNASSIGNED ? 'assignee:empty' : `assignee:eq:${encodeURIComponent(value)}`;
  if (field === 'assignedBy') return `assignedBy:eq:${encodeURIComponent(value)}`;
  if (field === 'due') return DUE_DSL[value] ?? '';
  return `${field}:eq:${encodeURIComponent(value)}`;
}

/** Умови всіх вибраних швидких полів через `;`. */
export function quickFieldsDsl(values: Readonly<Record<string, string>>): string {
  return Object.entries(values).map(([field, value]) => quickFieldDsl(field, value)).filter(Boolean).join(';');
}

/** Кількість вибраних швидких полів. */
export function quickFieldsCount(values: Readonly<Record<string, string>>): number {
  return Object.values(values).filter(Boolean).length;
}
